import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import LoadingPage from "./LoadingPage";
import PageFive from "./PageFive";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageSix from "./PageSix";
import PageSeven from "./PageSeven";
// import jsonFile from "./rpt-pmt-surveiKarakter.json";

const PageFour = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [headerSurvey, SetHeaderSurvey] = useState([]);
    const [surveyKarakter, SetSurveyKarakter] = useState([]);
    const [dataSummary, SetDataSummary] = useState([]);
    const [dataMembudaya, SetDataMembudaya] = useState([]);
    const [dataBaik, SetDataBaik] = useState([]);
    const [dataBerkembang, SetDataBerkembang] = useState([]);
    const [openPage, setOpenPage] = useState(false);
    const [isRiasec, setisRiasec] = useState(false);
    const [array, setArray] = useState([0, 1, 2, 3, 4, 5]);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_FOUR, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Two", error);
                });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Four ", responseAPI);
                    console.log("====================================");

                    SetHeaderSurvey(responseAPI.listHeader);
                    SetSurveyKarakter(responseAPI.listSurveyKarakter);
                    SetDataSummary(responseAPI.summary);
                    SetDataMembudaya(responseAPI.summary.membudaya);
                    SetDataBaik(responseAPI.summary.baik);
                    SetDataBerkembang(responseAPI.summary.berkembang);
                    setisRiasec(responseAPI.isRiasec);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="cardLine">
                    {/* header */}
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>06</span>
                        </div>
                        <div className="pnl-date">
                            https://eduprime.co.id/
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
                            <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', }}>
                            <div className="label-sub-tit">
                                <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '3%' }}>
                        <div>
                            <span className="title-header2" style={{ color: '#015E56', fontSize: '20px', }}>Rekapitulasi Survei Karakter</span>
                            <p style={{ color: '#015E56', fontSize: '16px', fontWeight: '500', marginTop: '10px' }}>Berdasarkan Aspek Profil Pelajar Pancasila</p>
                        </div>
                        <div style={{ width: '56%', display: 'flex', alignItems: 'flex-end' }}>
                            <div style={{ width: '100%', display: 'flex', gap: '20px', justifyContent: 'space-between' }}>
                                <div style={{ widt: '20px' }}>
                                    <span style={{ color: '##6C757D;', fontSize: '16px', fontWeight: '700' }}>Keterangan : </span>
                                </div>
                                <div style={{ widt: '20px', display: 'flex', gap: '10px', }}>
                                    <img src="/assets/image/verified_light_green.svg" width={"20px"} />
                                    <span style={{ color: '##6C757D;', fontSize: '16px', fontWeight: '700' }}>Membudaya</span>
                                </div>
                                <div style={{ widt: '20px', display: 'flex', gap: '10px' }}>
                                    <img src="/assets/image/mdi_ok.svg" width={"20px"} />
                                    <span style={{ color: '##6C757D;', fontSize: '16px', fontWeight: '700' }}>Berkembang</span>
                                </div>
                                <div style={{ widt: '20px', display: 'flex', gap: '10px' }}>
                                    <img src="/assets/image/mdi_check1_red.svg" width={"20px"} />
                                    <span style={{ color: '##6C757D;', fontSize: '16px', fontWeight: '700' }}>Perlu Ditingkatkan</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Gap height={20} />
                    <div className="rekap-table">
                        <Table size="sm" style={{ fontSize: 14 }}>
                            <thead
                                style={{
                                    backgroundColor: "#BEF264",
                                    fontSize: 15,
                                    textAlign: "center",
                                }}
                            >
                                <tr>
                                    <th width="10">No</th>
                                    <th
                                        height="50"
                                        style={{
                                            textAlign: "left",
                                        }}
                                    >
                                        Nama Siswa
                                    </th>
                                    {headerSurvey.map((dataHeader, i) => {
                                        return (
                                            <th key={i} width="130">
                                                {dataHeader.aspek}
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            {surveyKarakter.map((dataSurvey, j) => {
                                return (
                                    <tr
                                        key={j}
                                        height="40"
                                        style={{
                                            backgroundColor: "#F8F9FA",
                                            textAlign: "center",
                                        }}
                                    >
                                        <td>{j + 1}</td>
                                        <td style={{ textAlign: "left" }}>{dataSurvey.namaSiswa}</td>
                                        {dataSurvey.listSurveyKarakterSiswa.map((dataSurveySiswa, k) => {
                                            return (
                                                <td key={k}>
                                                    {isRiasec === false && dataSurveySiswa.kategori === "Unggul" ? (
                                                        <img src="/assets/image/mdi_ok.svg" width={25} alt={""} />
                                                    ) : isRiasec === false && dataSurveySiswa.kategori === "Baik" ? (
                                                        <img src="/assets/image/mdi_ok.svg" width={20} alt={""} />
                                                    ) : isRiasec === true && dataSurveySiswa.kategori === "Membudaya" ? (
                                                        <img src="/assets/image/verified_light_green.svg" width={25} alt={""} />
                                                    ) : isRiasec === true && dataSurveySiswa.kategori === "Berkembang" ? (
                                                        <img src="/assets/image/mdi_ok.svg" width={20} alt={""} />
                                                    ) : (
                                                        <img src="/assets/image/ling-colat.png" width={20} alt={""} />
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </Table>
                    </div>
                </div>
                <Gap height={20} />
            </div>

            <div className="report-page">
                <div className="cardLine">
                    {/* header */}
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>06</span>
                        </div>
                        <div className="pnl-date">
                            https://eduprime.co.id/
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
                            <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', }}>
                            <div className="label-sub-tit">
                                <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
                            </div>
                        </div>
                    </div>
                    <Gap height={40} />
                    <div>
                        <span className="title-header2" style={{ color: '#015E56', fontSize: '20px', }}>Rekapitulasi Survei Karakter</span>
                        <p style={{ color: '#015E56', fontSize: '16px', fontWeight: '500', marginTop: '10px' }}>Berdasarkan Aspek Profil Pelajar Pancasila</p>
                    </div>
                    <Gap height={20} />
                    <div className="card-tbl">
                        <div className="tbl-head">
                            <GridInline width={"100%"} padding={15} marginLeft={15}>
                                <GridInline width={"20%"} marginLeft={15} paddingTop={10} paddingBottom={10}>
                                    <LabelTitle label={""} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"20%"} marginLeft={15} paddingTop={10} paddingBottom={10}>
                                    <LabelTitle label={"Membudaya"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"20%"} textAlign={"center"}>
                                    <LabelTitle label={"Baik"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"20%"} textAlign={"center"}>
                                    <LabelTitle label={"Berkembang"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                            </GridInline>
                        </div>
                        <div className="table-result">
                            <div style={{ display: 'flex', gap: '10px', padding: '7px' }}>
                                <div style={{ width: '20%' }}>
                                    <div style={{ width: '100%', textAlign: 'center', padding: '15px' }}>
                                        <img src="/assets/image/la_atom.svg" width={50} alt={""} />
                                        <p style={{ fontSize: '14px' }}>Kebinekaan</p>
                                    </div>
                                    <div style={{ width: '100%', textAlign: 'center', padding: '15px' }}>
                                        <img src="/assets/image/mdi_gotyong.svg" width={50} alt={""} />
                                        <p style={{ fontSize: '14px' }}>Gotong Royong</p>
                                    </div>
                                    <div style={{ width: '100%', textAlign: 'center', padding: '15px' }}>
                                        <img src="/assets/image/mdi_idea.svg" width={50} alt={""} />
                                        <p style={{ fontSize: '14px' }}>Kreatif</p>
                                    </div>
                                    <div style={{ width: '100%', textAlign: 'center', padding: '15px' }}>
                                        <img src="/assets/image/mdi_brain.svg" width={50} alt={""} />
                                        <p style={{ fontSize: '14px' }}>Bernalar Kritis</p>
                                    </div>
                                    <div style={{ width: '100%', textAlign: 'center', padding: '15px' }}>
                                        <img src="/assets/image/mdi_person.svg" width={50} alt={""} />
                                        <p style={{ fontSize: '14px' }}>Mandiri</p>
                                    </div>
                                    <div style={{ width: '100%', textAlign: 'center', padding: '15px' }}>
                                        <img src="/assets/image/mdi_religion-islamic-darkgreen.svg" width={50} alt={""} />
                                        <p style={{ fontSize: '14px' }}>Beriman</p>
                                    </div>
                                </div>
                                <div style={{ width: '20%' }}>
                                    {array.map((item, index) => {
                                        return (
                                            <div key={index} style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px', height: '100px' }}>
                                                {dataMembudaya.length > item && (
                                                    <div className="label-sub-tit" style={{ backgroundColor: '#0097CE' }}>
                                                        <span style={{ fontSize: '18px', fontWeight: '600', color: '#FFF' }}>
                                                            Score : {dataMembudaya[item].indexSkorRiasec}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div style={{ width: '20%' }}>
                                    {array.map((item, index) => {
                                        return (
                                            <div key={index} style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px', height: '100px' }}>
                                                {dataBaik.length > item && (
                                                    <div className="label-sub-tit" style={{ backgroundColor: '#0097CE' }}>
                                                        <span style={{ fontSize: '18px', fontWeight: '600', color: '#FFF' }}>
                                                            Score : {dataBaik[item].skor}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div style={{ width: '20%' }}>
                                    {array.map((item, index) => {
                                        return (
                                            <div key={index} style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px', height: '100px' }}>
                                                {dataBerkembang.length > item && (
                                                    <div className="label-sub-tit" style={{ backgroundColor: '#0097CE' }}>
                                                        <span style={{ fontSize: '18px', fontWeight: '600', color: '#FFF' }}>
                                                            Score : {dataBerkembang[item].skor}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Gap height={20} />
                {openPage ? <PageSeven idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
            </div>
        </div>
    );
};

export default PageFour;
